<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{this.config.title}}</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="companiesLoaded == 'not_loaded'">Carregando cadastros...</div>
          <div v-if="companiesLoaded == 'error'">Algo errado. Não foi possível carregar os cadastros.</div>
          <div v-if="companiesLoaded == 'not_authorized'">Não foi possível carregar os cadastros. Você não foi autorizado.</div>
          <div v-if="companiesLoaded == 'empty'">{{this.config.empty}}</div>
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;" v-if="companies.length > 0">
              <v-container>
                <v-flex xs12>
                  <v-btn v-if="admin && showPartnerCreateBtn" absolute top right fab dark small color="primary" @click="gotoPage('/admin/partner/create')">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm7 py-0 pt-1>
                  </v-flex>
                  <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>  
                    <div class="font-weight-thin">Registros: {{companies.length}}</div>
                  </v-flex>
                  <v-flex xs12 pa-0>                    
                    <v-text-field v-model="companiesFilter" class="search-filter" append-icon="search"></v-text-field>                    
                  </v-flex>                 
                  <subject-item
                    @onUpdatePartner="onUpdatePartner"
                    @onUpdate="onUpdate"
                    @onReprove="onReprove"
                    @loadMoreRecords="loadCompanies"
                    :record="company"
                    :showConfigForm="config.showConfigForm"
                    v-for="company in companies"
                    :key="company.id"
                  />
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout column>
                  <v-flex xs12>
                    <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" @click="requestMoreRecords">
                      EXIBIR MAIS
                    </v-btn>
                    <slot></slot>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import SubjectItem from "./SubjectItem"

export default {
  name: 'AdminSubjects',
  components: { layout: LeftBarLayout, 'subject-item': SubjectItem },
  props: {
    config: {
      type: Object
    },
    showPartnerCreateBtn: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      companies: [],
      companiesLoaded: 'not_loaded',
      companiesFilter: '',
      loading: false
    }
  },
  computed: {
    showMoreBtn() {
      if ((this.companies.length > 0) && (this.companies.length % 100 == 0)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    this.loadCompanies(null)
  },
  methods: {
    requestMoreRecords(e) {
      if (this.loading == false) {
        this.loadCompanies(this.getLastRecordId())
      }
    },
    getLastRecordId() {
      let lastId = this.companies.length - 1
      return this.companies[lastId]['id']
    },
    loadCompanies(last_id) {
      let successCallback = (response) => {
        this.loading = false

        if (response.body.data) {
          this.companies = this.companies.concat(...response.body.data)

          if (this.companies.length === 0) {
            this.companiesLoaded = 'empty'
          } else {
            this.companiesLoaded = 'ok'
          }
        } else {
          this.companiesLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }
      }

      let errorCallback = (response) => {
        this.loading = false

        if (response.status === 401) {
          this.companiesLoaded = 'not_authorized'
        } else {
          this.companiesLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      this.loading = true
      let token = this.$cookies.get('api_token')
      this.$http.get(this.config.load_url, { params: { last_id: last_id }, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    onUpdate(record) {
      this.$emit('onUpdate', this.companies, record)
    },
    onUpdatePartner(updatedRecord) {
      let index = this.companies.findIndex(company => company.id === updatedRecord.id);
      if(index !== -1) {
        this.$set(this.companies, index, updatedRecord);
      }
    },
    onReprove(record) {
      this.$emit('onReprove', this.companies, record)
    },
    gotoPage(path) {
      this.$router.push(path).catch(err => {})
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>




// WEBPACK FOOTER //
// src/AdminSubjects.vue